import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DiscountType, ModalDialogType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { Discount } from 'src/app/models/discount';

@Component({
  selector: 'pos-change-price-modal',
  templateUrl: './pos-change-price-modal.component.html',
  styleUrls: ['./pos-change-price-modal.component.sass']
})
export class PosChangePriceModalComponent implements OnInit {

  price: Number = new Number();
  private confirmAction: (value: Number) => any = (value: Number) => { };

  changePriceForm: FormGroup = this.formBuilder.group(
    {
      discountValue: new FormControl("", [Validators.min(1), Validators.required])
    }
  );
  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder, private confirmDialogService: PosConfirmationService) {
  }

  ngOnInit(): void { }

  confirm() {
    this.confirmAction(Number(this.changePriceForm.get("discountValue")?.value));
    this.bsModalRef.hide();
  }

  cancel() {
    this.bsModalRef.hide();
  }

  load() {
    this.changePriceForm.get("discountValue")?.setValue(this.price);
  }
}
